var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._b({staticClass:"toggle-button",class:{ toggled: _vm.toggled },on:{"click":function($event){return _vm.$emit('toggle', !_vm.toggled)}}},'Button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }